<template>
    <span>
        <a href="#" @click="showpop">{{$common.dicword('clickhere')}}</a>

        <el-dialog v-if="isshowpop" :visible.sync="isshowpop" top="0px" class="mydialog2 modulewrap" append-to-body>
            <myScroll class="scroll ">
                <div class="mypoplearnerwrap">
                    <Clearner :navsub="k" :options="options"></Clearner>
                </div>

            </myScroll>

        </el-dialog>
    </span>

</template>


<script>
    export default {
        name: 'fflearner',
        components: {
            Clearner: () => import('@/components/Clearner')
        },
        data() {
            return {
                isshowpop: false
            }
        },
        props: {
            options: {
                type: Object,
                default: () => { }
            },
            k: {
                type: Number,
                default: 0
            }
        },
        methods: {
            showpop: function () {
                this.isshowpop = true;
            }
        }
    }
</script>
